var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.3125C4.64844 0.3125 0.3125 4.64844 0.3125 10C0.3125 15.3516 4.64844 19.6875 10 19.6875C15.3516 19.6875 19.6875 15.3516 19.6875 10C19.6875 4.64844 15.3516 0.3125 10 0.3125Z",
    fill: "#00A1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 7.5C13.4375 5.60156 11.8984 4.0625 10 4.0625C8.10156 4.0625 6.5625 5.60156 6.5625 7.5C6.5625 9.39844 8.10156 10.9375 10 10.9375C11.8984 10.9375 13.4375 9.39844 13.4375 7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27734 14.8359C5.65234 16.4609 7.70703 17.5 10 17.5C12.293 17.5 14.3477 16.4609 15.7227 14.8359C14.9883 13.4531 13.5508 12.5 11.875 12.5C11.7812 12.5 11.6875 12.5156 11.5977 12.543C11.0938 12.707 10.5586 12.8125 10 12.8125C9.44141 12.8125 8.91016 12.707 8.40234 12.543C8.3125 12.5156 8.21875 12.5 8.125 12.5C6.44922 12.5 5.01172 13.4531 4.27734 14.8359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_2127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6a72a286c1a7e8da1b81fe9fdf3fdb20.svg";
export { ForwardRef as ReactComponent };